import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

// Enum options extracted from SQL structure:
// CREATE TYPE public.s1_metadata_field_key AS ENUM ('alternative_type');
export const fieldKeyOptions = [
  { value: "alternative_type", label: "Alternative Type" },
];

// Field value options for S1Metadata from Ruby admin form
export const fieldValueOptions = [
  { value: "Long/Short Credit", label: "Long/Short Credit" },
  { value: "Long/Short Equity", label: "Long/Short Equity" },
  { value: "Global Macro", label: "Global Macro" },
  { value: "Other", label: "Other" },
];

export const filterS1MetadataSchema = z.object({
  field_key_equals: z.string().optional(),
});

export type FilterS1MetadataSchema = z.infer<typeof filterS1MetadataSchema>;

export const fields: Field[] = [
  {
    name: "field_key_equals",
    label: "Field Key",
    type: "select",
    useTranslation: false,
    options: fieldKeyOptions,
  },
];

export const client = "s1-quantilia";

export function FilterS1Metadata() {
  return (
    <FilterTable
      client={client}
      schema={filterS1MetadataSchema}
      tableName="s1_metadata"
      customBuildPath={() => `${client}/s1_metadata`}
      fields={fields}
    />
  );
}
